<template>
  <div class="check-secret-container">
    <div class="background">
      <svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 24 24" style="fill:none;stroke-linejoin:round;stroke-width:2;stroke:currentColor"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
    </div>
    <div class="content">
      <div class="header">Password Protected</div>
      <p>Copy and Paste your gallery password here:</p>
      <div class="secret">
        <input type="text" class="input" v-model="secret"/>
      </div>
      <div v-if="this.invalid" class="invalid">
        The password you entered is invalid.
      </div>
      <div class="unlock" 
        @click="unlock()"
        @mouseover="lockHover = true"
        @mouseout="lockHover = false"
        :disabled="secret.length < 1">
        <span v-if="loading"><i class="fa fa-spin fa-circle-notch"/></span>
        <span v-else-if="unlocked"><i class="fa fa-check"/></span>
        <span v-else><i class="fa" :class="lockHover ? 'fa-unlock' : 'fa-lock'"/></span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

const baseURL = 'https://simply-studio.appspot.com' //process.env.VUE_APP_BACKEND_URL

export default {
  name: 'CheckSecret',
  props: {
    user: {
      type: String,
      required: true
    },
    projectName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      secret: '',
      lockHover: false,
      invalid: false,
      unlocked: false,
      loading: false,
    }
  },
  methods: {
    async unlock() {
      this.loading = true
      let valid = await axios.post(baseURL + '/validate-secret', 
        {
          user: this.user,
          projectName: this.projectName,
          secret: this.secret
        },
        {
          handlerEnabled: false
        }).then(res => res.data)
      
      this.loading = false
      if(!valid) {
        this.invalid = true
        return
      }
      this.unlocked = true
      this.$emit('unlock', this.secret)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';
.check-secret-container {
  border-radius: $border-radius;
  padding: 10px;
  max-width: 350px;
  // max-width: 90vw;
  height: 300px;
  margin-bottom: 50px;
  font-size: 18px;
  @include shadow;
  text-align: left;
  position: relative;
  margin: auto;

  .background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    
    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      opacity: 0.07;
    }
  }

  .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 20px;
    .header {
      font-weight: 700;
      padding: 10px 0px;
      font-size: 18px;
      color: $primary;
    }

    font-size: 16px;
    color: $primaryText;

    .secret {
      .input {
        background: rgba(255, 255, 255, 0.5);
      }
    }

    .unlock {
      color: white; 
      font-size: 30px;
      padding: 10px 20px;
      border-radius: $border-radius;
      border: 1px solid white;
      margin-top: 20px; 
      background-color: $primary;
      float: right;
      cursor: pointer;

      &:hover {
        @include shadow;
      }
    }
  }
}

.invalid {
  color: $red;
}
</style>